import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const HUB_API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "hub_customer_token";
const USER_KEY = "hub_customer_user";

export const hubApi = axios.create({ baseURL: HUB_API });

hubApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

hubApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (
      e?.response?.status === 401 &&
      window.location.pathname.startsWith("/mon-espace") &&
      !["/mon-espace/login", "/mon-espace/set-password"].some((p) => window.location.pathname.startsWith(p))
    ) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      window.location.href = "/mon-espace/login";
    }
    return Promise.reject(e);
  }
);

export const hubCustomerAuth = {
  setSession(token, user) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  getUser() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || "null");
    } catch {
      return null;
    }
  },
  isAuthed() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
};
